import { brandPrimary, charmGray, shuffleGray, white } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	primaryTabList: {
		boxSizing: 'border-box',
		display: 'flex',
		':is([data-orientation="horizontal"])': {
			minHeight: 40,
			borderBottom: `1px solid ${shuffleGray}`,
		},
		':is([data-orientation="vertical"])': {
			flexDirection: 'column',
			height: 'fit-content',
			borderRight: `1px solid ${shuffleGray}`,
		},
	},
	primaryTabTrigger: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: `12px 16px`,
		cursor: 'pointer',
		border: 'none',
		background: 'none',
		color: charmGray,
		fontSize: 14,
		':hover': {
			backgroundColor: '#f7fafc',
		},
		':is([data-disabled])': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
		':is([data-disabled]):hover': {
			backgroundColor: white,
		},
		':is([data-state="active"])': {
			color: brandPrimary,
		},
		':is([data-orientation="horizontal"][data-state="active"])': {
			boxShadow: `0 2px 0 ${brandPrimary}`, // covers bottom border without using negative margin
		},
		':is([data-orientation="vertical"])': {
			width: '100%',
			justifyContent: 'flex-start',
		},
		':is([data-orientation="vertical"][data-state="active"])': {
			borderRight: `1px solid ${brandPrimary}`,
		},
	},
});
